const formatMoney = (value) => {
  if (!value) {
    return "0.00";
  }

  return parseFloat(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default formatMoney;
